<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title mb-1">Preço por período</h5>
      <p class="small text-muted">
        Opcional. A festa usa a menor faixa que cobre a duração. Acima da maior faixa (ou sem faixas),
        vale o preço por evento: <strong>{{ money(eventPrice) }}</strong>.
      </p>

      <div v-if="loading" class="text-center p-2">
        <div class="spinner-border spinner-border-sm" role="status"></div>
      </div>

      <template v-else>
        <div v-for="(regra, i) in regras" :key="i" class="row g-2 align-items-center mb-2">
          <div class="col-5">
            <div class="input-group input-group-sm">
              <span class="input-group-text">Até</span>
              <input v-model.number="regra.max_hours" type="number" min="1" max="744" class="form-control" aria-label="Horas">
              <span class="input-group-text">horas</span>
            </div>
          </div>
          <div class="col-5">
            <div class="input-group input-group-sm">
              <span class="input-group-text">R$</span>
              <input v-model.number="regra.price" type="number" min="0" step="0.01" class="form-control" aria-label="Preço">
            </div>
          </div>
          <div class="col-2 text-end">
            <button type="button" class="btn btn-sm btn-outline-danger" @click="regras.splice(i, 1)" aria-label="Remover faixa">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3">
          <button type="button" class="btn btn-sm btn-outline-primary" @click="regras.push({ max_hours: null, price: null })">
            <i class="bi bi-plus me-1"></i>Adicionar faixa
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="salvar" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Salvar faixas
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { itens } from '@/models/itens';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';

export default {
  name: 'PriceRulesEditor',
  props: {
    itemId:     { type: [Number, String], required: true },
    eventPrice: { type: [Number, String], default: 0 },
  },
  setup(props) {
    const toastStore = useToastStore();
    const model = itens();
    const regras = ref([]);
    const loading = ref(false);
    const saving = ref(false);

    async function carregar() {
      loading.value = true;
      try {
        regras.value = (await model.getPriceRules(props.itemId))
          .map(r => ({ max_hours: r.max_hours, price: Number(r.price) }));
      } catch (error) {
        toastStore.error('Erro ao carregar faixas de preço: ' + parseError(error));
      }
      loading.value = false;
    }

    async function salvar() {
      if (regras.value.some(r => !r.max_hours || r.price === null || r.price === '')) {
        toastStore.warning('Preencha horas e preço de todas as faixas.');
        return;
      }
      saving.value = true;
      try {
        regras.value = (await model.setPriceRules(props.itemId, regras.value))
          .map(r => ({ max_hours: r.max_hours, price: Number(r.price) }));
        toastStore.success('Faixas de preço salvas.');
      } catch (error) {
        toastStore.error('Erro ao salvar faixas: ' + parseError(error));
      }
      saving.value = false;
    }

    function money(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    onMounted(carregar);

    return { regras, loading, saving, salvar, money };
  }
}
</script>
